module.exports = __webpack_public_path__ + "img/jaymethodstwo-349a4b03-eee0-43cc-d668-08d957755ecc.png";